<template>
  <div id="conf">
    <!-- for the confetti effect -->
  </div>
  <v-container
    fluid
    class="fill-height pa-0"
  >
    <v-layout class="fill-height pa-0">
      <v-row class="fill-height ma-0">
        <v-col
          class="bg-primary hidden-sm-and-down"
          cols="12"
          md="5"
        >
          <background-particles />
          <div>
            <v-img
              class="mt-6"
              src="@/assets/eye-academy-logo-dark.svg"
              max-height="20"
              contain
            ></v-img>
            <Vue3Lottie
              class="mt-12"
              :animationData="OnboardJSON"
              :width="300"
              :height="300"
            />
          </div>
        </v-col>
        <v-col
          cols="12"
          md="7"
          class="align-self-center pa-3 pa-md-12"
        >
          <v-img
            class="mb-6"
            src="@/assets/eye-academy-logo-light.svg"
            max-height="20"
            contain
          ></v-img>

          <v-window
            v-model="currentStep"
            class="rounded-xl text-primary"
            min-height="500"
            :touch="handleSwipe"
          >
            <v-window-item :value="1">
              <v-card
                class="text-center"
                min-height="370"
                elevation="0"
                variant="outlined"
              >
                <v-card-title> Welcome! </v-card-title>
                <v-card-subtitle> Let's get you set up. </v-card-subtitle>
                <v-card-text>
                  <v-text-field
                    class="px-md-12 pt-6"
                    v-model="firstName"
                    label="First Name*"
                    autocomplete="given-name"
                    type="text"
                  ></v-text-field>
                  <v-text-field
                    class="px-md-12"
                    v-model="lastName"
                    label="Last Name*"
                    autocomplete="family-name"
                    type="text"
                  ></v-text-field>
                  <v-select
                    class="px-md-12"
                    variant="outlined"
                    v-model="year"
                    label="Grade"
                    :items="[
                      'ST1 (UK)',
                      'ST2 (UK)',
                      'ST3 (UK)',
                      'ST4 (UK)',
                      'ST5 (UK)',
                      'ST6 (UK)',
                      'ST7 (UK)',
                      'Resident (Non-UK)',
                      'Fellow',
                      'Other',
                    ]"
                  >
                  </v-select>
                  <v-combobox
                    class="px-md-12"
                    v-model="hospital"
                    :items="Hospitals"
                    label="Hospital/Institution"
                    type="text"
                  >
                  </v-combobox>
                  <v-text-field
                    class="px-md-12 text-left"
                    v-model="examDate"
                    label="Exam Date"
                    type="date"
                    persistent-hint
                    :hint="examDateHint"
                    @change="examDateNotValid(examDate)"
                  ></v-text-field>
                  <!-- <div class="px-md-12">
                    <v-btn
                      :disabled="
                        firstName.trim() === '' || lastName.trim() === ''
                      "
                      @click="currentStep++"
                      color="primary"
                      block
                      rounded="lg"
                      variant="flat"
                    >
                      Continue
                    </v-btn>
                  </div> -->
                  <div class="px-md-12">
                    <v-btn
                      class="mt-6"
                      :disabled="
                        firstName.trim() === '' || lastName.trim() === ''
                      "
                      @click="saveUserDetails"
                      color="primary"
                      block
                      rounded="lg"
                      variant="flat"
                    >
                      Go to your Dashboard
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-window-item>
            <!-- 
            <v-window-item :value="2">
              <v-card
                class="text-center"
                min-height="370"
                elevation="0"
                variant="outlined"
              >
                <v-card-title> Nice to meet you! 😊 </v-card-title>
                <v-card-subtitle>
                  We just have a few more questions.
                </v-card-subtitle>
                <v-card-text>
                  <v-combobox
                    class="px-md-12"
                    v-model="hear"
                    :items="[
                      'Google',
                      'Facebook',
                      'Word of Mouth',
                      'Other - specify here: ',
                    ]"
                    label="How did you hear about us?"
                    type="text"
                  >
                  </v-combobox>
                  <div class="px-md-12">
                    <v-btn
                      :disabled="!year || !hospital || !hear"
                      color="primary"
                      block
                      rounded="lg"
                      variant="flat"
                      @click="currentStep++"
                    >
                      Continue
                    </v-btn>
                  </div>
                  <div class="px-md-12 pt-3">
                    <v-btn
                      @click="currentStep--"
                      variant="tonal"
                      color="primary"
                      block
                      rounded="lg"
                    >
                      Back
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-window-item>

            <v-window-item :value="3">
              <v-card
                class="text-center"
                min-height="370"
                elevation="0"
                variant="outlined"
              >
                <v-card-title> One More Thing! </v-card-title>
                <v-card-subtitle> When is your exam?? </v-card-subtitle>
                <v-card-text>
                  <div class="px-md-12 mt-3">
                    <v-btn
                      :disabled="examDateNotValid(examDate)"
                      @click="currentStep++"
                      color="primary"
                      block
                      rounded="lg"
                      variant="flat"
                    >
                      Continue
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-window-item>

            <v-window-item :value="4">
              <v-card
                class="text-center"
                min-height="370"
                elevation="0"
                variant="outlined"
              >
                <v-card-title> Let us show you around! </v-card-title>
                <v-card-subtitle>
                  Watch this short video to learn <br />
                  how to use Eye Academy.
                </v-card-subtitle>
                <v-card-text>
                  <div
                    class="my-4"
                    style="
                      position: relative;
                      padding-bottom: 64.5933014354067%;
                      height: 0;
                    "
                  >
                    <iframe
                      src="https://www.loom.com/embed/3a1a4d197072435da62ae11ad1a403e9?sid=05b001e5-79aa-401d-a04a-fcff05d55825"
                      frameborder="0"
                      webkitallowfullscreen
                      mozallowfullscreen
                      allowfullscreen
                      style="
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                      "
                    ></iframe>
                  </div>
                  <v-btn
                    class="mt-6"
                    :disabled="missingFields"
                    @click="$router.replace('/')"
                    color="primary"
                    block
                    rounded="lg"
                    variant="flat"
                  >
                    Go to your Dashboard
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-window-item> -->
          </v-window>
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script setup>
  import { ref, watch, onMounted, computed } from "vue";
  import { useReward } from "vue-rewards";
  import OnboardJSON from "@/assets/onboarding.json";
  import Hospitals from "@/assets/hospitals.json";
  import BackgroundParticles from "@/components/BackgroundParticles.vue";
  import { useUserStore } from "@/store/user";
  import { useRouter } from "vue-router";
  const router = useRouter();

  // Stop swiping left/right
  const handleSwipe = computed(() => {
    return {
      // noops to prevent swiping left/right
      right: () => {},
      left: () => {},
    };
  });

  // Confetti at the beginning
  const { reward: confettiReward } = useReward("conf", "confetti", {
    elementCount: 100,
    spread: 180,
    elementSize: 10,
  });
  onMounted(() => {
    confettiReward();
  });

  // v-sheet stepper
  const currentStep = ref(1);

  // const checkForEnterKey = (e) => {
  //   if (e.key === "Enter") {
  //     currentStep.value++;
  //   }
  // };

  // Form fields
  const firstName = ref("");
  const lastName = ref("");
  const year = ref(null);
  const hospital = ref(null);
  const hear = ref(null);
  const examDate = ref(null);
  const examDateHint = ref("");

  const examDateNotValid = (date) => {
    if (!date) return true;
    const today = new Date();
    const examDate = new Date(date);
    const hundredYearsFromNow = new Date();
    hundredYearsFromNow.setFullYear(today.getFullYear() + 100);
    if (examDate < today) {
      examDateHint.value = "Must be in the future!";
      return true;
    } else if (examDate > hundredYearsFromNow) {
      examDateHint.value = "Will you even be alive?!";
      return true;
    } else {
      examDateHint.value = "";
    }
  };

  // Confetti at the end and saving user details
  const { reward: emojiReward } = useReward("conf", "emoji", {
    elementCount: 15,
  });
  const { reward: balloonReward } = useReward("conf", "balloons", {
    elementCount: 10,
  });

  const userStore = useUserStore();
  const saveUserDetails = async () => {
    await userStore.onboardUser({
      firstName: firstName.value,
      lastName: lastName.value,
      year: year.value,
      hospital: hospital.value,
      hear: hear.value,
      examDate: examDate.value,
    });
    router.replace("/");
  };
  // watch(currentStep, (newVal) => {
  //   // only show once they get to the video
  //   if (newVal === 4) {
  //     emojiReward();
  //     balloonReward();
  //     saveUserDetails();
  //   }
  // });

  // If there are any missing fields don't allow them
  // to go to the dashboard
  // const missingFields = computed(() => {
  //   return (
  //     !firstName.value ||
  //     !lastName.value ||
  //     !year.value ||
  //     !hospital.value ||
  //     !hear.value ||
  //     !examDate.value
  //   );
  // });
</script>

<style scoped>
  #conf {
    position: absolute;
    top: 200px;
    left: 50%;
    z-index: 99999;
  }
</style>
